export default __webpack_public_path__ + "static/media/svgtracepro.a2d1c733.mov";